module.exports = __webpack_public_path__ + "assets/d4118c38579d477cec1f9f686531fdf4.jpg";